var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "van-list",
        {
          staticClass: "list",
          attrs: {
            "loading-text": "loading...",
            finished: _vm.finished,
            "finished-text": ""
          },
          on: { load: _vm.getSellerList },
          model: {
            value: _vm.loading,
            callback: function($$v) {
              _vm.loading = $$v
            },
            expression: "loading"
          }
        },
        [
          _vm.sellerList.length > 0
            ? _c(
                "div",
                _vm._l(_vm.sellerList, function(item, index) {
                  return _c("div", { key: index, staticClass: "item" }, [
                    _c("div", { staticClass: "item_head" }, [
                      _c("div", { staticClass: "fc-relative" }, [
                        _c("img", {
                          staticClass: "user_photo",
                          attrs: { src: item.img }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "flag",
                          attrs: { src: item.logo }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "user_info" }, [
                        _c("div", { staticClass: "title_ID" }, [
                          _c("span", { staticClass: "title fc-elip-2" }, [
                            _vm._v(_vm._s(item.nickname))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "ids" }, [
                            _c("span", { staticClass: "id" }, [
                              _vm._v("ID:" + _vm._s(item.userId))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "copyBtn",
                              attrs: { src: require("../assets/img/copy.png") },
                              on: {
                                click: function($event) {
                                  return _vm.copyActiveCode($event, item.userId)
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "balance" }, [
                          _c(
                            "span",
                            { staticClass: "balance_title fc-elip-1" },
                            [_vm._v(_vm._s(_vm.$t("m.buy_balance")))]
                          ),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "icon",
                            attrs: { src: require("../assets/img/diamond.png") }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.diamond))
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "paytype" }, [
                      _c(
                        "div",
                        { staticClass: "paytype_list" },
                        _vm._l(item.payTypes, function(pay, i) {
                          return _c("div", { staticClass: "imgbox" }, [
                            _c("img", { attrs: { src: pay.payTypeImg } })
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sellerList.length < 1 && _vm.userInfo.userId
            ? _c("div", { staticClass: "nodataImg" }, [
                _c("img", {
                  attrs: { src: require("../assets/img/nodata.png"), alt: "" }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sellerList.length < 1 && !_vm.userInfo.userId
            ? _c("div", { staticClass: "noLogin" }, [
                _c("div", { staticClass: "noLoginImg" }, [
                  _c("img", {
                    attrs: {
                      src: require("../assets/img/noLogin.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "loginTip" }, [
                    _vm._v(_vm._s(_vm.$t("m.login_after_recharge")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fc-btn-line-login",
                    on: {
                      click: function($event) {
                        return _vm.$router.push("/login")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.login")))]
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7de1a0f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de1a0f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sellers.vue
// module id = null
// module chunks = 